import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/client';

export const fetchProfile = createAsyncThunk(
    'profile/fetchProfile',
    async (userId, { rejectWithValue }) => {
        if (!userId) return rejectWithValue('No userId provided');
        try {
            const response = await api.get(`/auth/profile/${userId}`);
            return response.data;
        } catch (error) {
            console.error('Profile fetch error:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch profile');
        }
    }
);



export const fetchmarket = createAsyncThunk(
    'profile/fetchmarket',
    async (userId, { rejectWithValue }) => {
        if (!userId) return rejectWithValue('No userId provided');
        try {
            const response = await api.get(`/bets/exposure/summary/${userId}`);
            return response.data;
        } catch (error) {
            console.error('Profile fetch error:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch profile');
        }
    }
);


export const fetchAccountStament = createAsyncThunk(
    'profile/fetchAccountStament',
    async (userId, { rejectWithValue }) => {
        if (!userId) return rejectWithValue('No userId provided');

        try {
            const response = await api.get(`/account-statement/${userId}`);
            return response.data;
        } catch (error) {
            if (error.response?.status === 401) throw error;
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch account statement');
        }
    }
);

export const fetchcricketAccountStament = createAsyncThunk(
    'profile/fetchcricketAccountStament',
    async (userId, { rejectWithValue }) => {
        if (!userId) return rejectWithValue('No userId provided');

        try {
            const response = await api.get(`/account-statement/cricket/${userId}`);
            return response.data;
        } catch (error) {
            if (error.response?.status === 401) throw error;
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch account statement');
        }
    }
);



export const fetchCasinoAccountStament = createAsyncThunk(
    'profile/fetchCasinoAccountStament',
    async (userId, { rejectWithValue }) => {
        if (!userId) return rejectWithValue('No userId provided');

        try {
            const response = await api.get(`account-statement/casino/${userId}`);
            return response.data;
        } catch (error) {
            if (error.response?.status === 401) throw error;
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch account statement');
        }
    }
);

// ─── Games Statement ───────────────────────────────────────────────────
export const fetchGamesStatement = createAsyncThunk(
    'profile/fetchGamesStatement',
    async ({ userId, matchId, marketType, selection }, { rejectWithValue }) => {
        try {
            const response = await api.get(
                `/account-statement/description/${userId}/${matchId}/${marketType}?selection=${encodeURIComponent(selection)}`
            );
            return response.data;
        } catch (error) {
            if (error.response?.status === 401) throw error;
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch games statement');
        }
    }
);



// ─── casino  Games Statement ───────────────────────────────────────────────────
export const getCasinogameStatment = createAsyncThunk(
    'profile/getCasinogameStatment',
    async ({ userId, gameId, roundId }, { rejectWithValue }) => {
        try {
            const response = await api.get(
                `/casino/details/${userId}/${gameId}/${roundId}`
            );

            return response.data;
        } catch (error) {
            // Re-throw unauthorized errors
            if (error.response?.status === 401) {
                throw error;
            }

            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                'Failed to fetch casino game statement'
            );
        }
    }
);

// ─── casino  Games Statement bets  histroy ───────────────────────────────────────────────────
export const getCasinoSettlebet = createAsyncThunk(
    'profile/getCasinoSettlebet',
    async (userId  , { rejectWithValue }) => {
        try {
            const response = await api.get(
                `/bets/casino/settle-bets/${userId}`
            );

            return response.data;
        } catch (error) {
            // Re-throw unauthorized errors
            if (error.response?.status === 401) {
                throw error;
            }

            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                'Failed to fetch casino game statement'
            );
        }
    }
);

// ─── casino  Games Statement bets  histroy ───────────────────────────────────────────────────
export const getCasinoOpenbet = createAsyncThunk(
    'profile/getCasinoOpenbet',
    async (userId  , { rejectWithValue }) => {
        try {
            const response = await api.get(
                `/bets/casino/open-bets/${userId}`
            );

            return response.data;
        } catch (error) {
            // Re-throw unauthorized errors
            if (error.response?.status === 401) {
                throw error;
            }

            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                'Failed to fetch casino game statement'
            );
        }
    }
);





const profileSlice = createSlice({
    name: 'profile',
    initialState: {
        data: {
            username: sessionStorage.getItem('profile_username') || '',
            balance: parseFloat(sessionStorage.getItem('profile_balance')) || 0,
            exp: parseFloat(sessionStorage.getItem('profile_exp')) || 0
        },
        fetchmarketData: [],
        AccountStamentData: [],
        GamesStamentData: [],
        CasinogameStatment:[],
        cricketAccountStament:[],
        CasinoOpenbet:[],
        CasinoAccountStament:[],
        CasinoSettlebet:[],
        whatsappData: null,
        loading: false,
        error: null
    },

    reducers: {

        resetProfile: (state) => {
            // Clear in-memory Redux state
            state.data = { username: '', balance: 0, exp: 0 };
            state.fetchmarketData = [];
            state.loading = false;
            state.error = null;

            // Clear sessionStorage — this is the actual fix
            sessionStorage.removeItem('profile_username');
            sessionStorage.removeItem('profile_balance');
            sessionStorage.removeItem('profile_exp');
        },
    },

    extraReducers: (builder) => {
        builder
            // Fetch Profile
            .addCase(fetchProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;

                // Save to sessionStorage
                if (action.payload.username) sessionStorage.setItem('profile_username', action.payload.username);
                if (action.payload.balance !== undefined) sessionStorage.setItem('profile_balance', action.payload.balance);
                if (action.payload.exp !== undefined) sessionStorage.setItem('profile_exp', action.payload.exp);
            })
            .addCase(fetchProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch profile';
            })

            // Fetch Market
            .addCase(fetchmarket.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchmarket.fulfilled, (state, action) => {
                state.loading = false;
                state.fetchmarketData = action.payload || [];
            })
            .addCase(fetchmarket.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch market';
            })

            // Account Statement
            .addCase(fetchAccountStament.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAccountStament.fulfilled, (state, action) => {
                state.loading = false;
                state.AccountStamentData = action.payload || [];
            })
            .addCase(fetchAccountStament.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch account statement';
            })

            // Games Statement
            .addCase(fetchGamesStatement.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchGamesStatement.fulfilled, (state, action) => {
                state.loading = false;
                state.GamesStamentData = action.payload || [];
            })
            .addCase(fetchGamesStatement.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch games statement';
            })

           


            // casino fectyh for accoutn stataemtn gam ssatemnt 
            .addCase(getCasinogameStatment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCasinogameStatment.fulfilled, (state, action) => {
                state.loading = false;
                state.CasinogameStatment = action.payload;
            })
            .addCase(getCasinogameStatment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch whatsapp number';
            })


            // casino  sttel bets 
            .addCase(getCasinoSettlebet.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCasinoSettlebet.fulfilled, (state, action) => {
                state.loading = false;
                state.CasinoSettlebet = action.payload;
            })
            .addCase(getCasinoSettlebet.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch whatsapp number';
            })

             // casino open bets 
            .addCase(getCasinoOpenbet.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCasinoOpenbet.fulfilled, (state, action) => {
                state.loading = false;
                state.CasinoOpenbet = action.payload;
            })
            .addCase(getCasinoOpenbet.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch whatsapp number';
            })


              // fetchcricketAccountStament
            .addCase(fetchcricketAccountStament.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchcricketAccountStament.fulfilled, (state, action) => {
                state.loading = false;
                state.cricketAccountStament = action.payload;
            })
            .addCase(fetchcricketAccountStament.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch whatsapp number';
            })


             // fetchCasinoAccountStament
            .addCase(fetchCasinoAccountStament.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCasinoAccountStament.fulfilled, (state, action) => {
                state.loading = false;
                state.CasinoAccountStament = action.payload;
            })
            .addCase(fetchCasinoAccountStament.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch whatsapp number';
            });

              
    },
});

export const { resetProfile } = profileSlice.actions;
export default profileSlice.reducer;